import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useVariables = (type, config) => {
  return useQuery({
    ...config,
    queryKey: `text-variables-${type}`,
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/text-variables/${type}`,
        signal,
      }),
  });
};
